// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginModal-lineThrough-GwwzN {
	position: relative;
	z-index: 1;
	display: block;
	width: 100%;
	text-align: center;
	font-weight: 600;
	font-size: 18px;
	margin: 18px 0px;
}

.LoginModal-lineThrough-GwwzN::before {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: -1;
	margin-top: -5px;
	margin-left: -20px;
	width: 40px;
	height: 10px;
	background-color: var(--primary-white-bg);
	content: '';
}

.LoginModal-lineThrough-GwwzN::after {
	position: absolute;
	top: 49%;
	z-index: -2;
	display: block;
	width: 100%;
	border-bottom: 1px solid var(--primary-border);
	content: '';
}

.LoginModal-carImage-DDYiM {
	max-width: 480px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	border-radius: 12px;
}

@media screen and (max-width:767px) {

	.LoginModal-carImage-DDYiM {
		display: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,yCAAyC;CACzC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,cAAc;CACd,WAAW;CACX,8CAA8C;CAC9C,WAAW;AACZ;;AAGA;CACC,gBAAgB;CAChB,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,mBAAmB;AACpB;;AAGA;;CAEC;EACC,aAAa;CACd;AACD","sourcesContent":[".lineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\twidth: 100%;\n\ttext-align: center;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tmargin: 18px 0px;\n}\n\n.lineThrough::before {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tz-index: -1;\n\tmargin-top: -5px;\n\tmargin-left: -20px;\n\twidth: 40px;\n\theight: 10px;\n\tbackground-color: var(--primary-white-bg);\n\tcontent: '';\n}\n\n.lineThrough::after {\n\tposition: absolute;\n\ttop: 49%;\n\tz-index: -2;\n\tdisplay: block;\n\twidth: 100%;\n\tborder-bottom: 1px solid var(--primary-border);\n\tcontent: '';\n}\n\n\n.carImage {\n\tmax-width: 480px;\n\twidth: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n\tborder-radius: 12px;\n}\n\n\n@media screen and (max-width:767px) {\n\n\t.carImage {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lineThrough": `LoginModal-lineThrough-GwwzN`,
	"carImage": `LoginModal-carImage-DDYiM`
};
module.exports = ___CSS_LOADER_EXPORT___;
